<template>
  <div class="result">
    <div class="layout">
      <div class="sucPrompt">
        <img src="@/assets/images/template/success.png">
        <span>账号开立成功</span>

        <div class="description">
          MT5/CFD 真实账户：{{ accountNo }}
          <br>
          <br>
          请以相同账户密码登录 MT5 平台
          <br>
          <br>
          点击返回登录以启动您的 MT5 账户
        </div>

        <div class="btn-container">
          <button @click="goToLogin">返回登录</button>
        </div>
      </div>
    </div>
    <Chat />
  </div>
</template>

<script>
require('@/assets/css/result.css')
import Chat from '@/view/module/Chat.vue'
import { mapState } from 'vuex'

export default {
  name: 'AddMT5Result',
  components: { Chat },
  computed: {
    ...mapState(['pageType'])
  },
  data() {
    return {
      accountNo: this.$route.query.accountNo ? this.$route.query.accountNo : '加载中...'
    }
  },
  methods: {
    goToLogin() {
      if (this.pageType == 'app') {
        window.location.href = 'https://gologin'
        return
      }
      this.$router.replace({ path: '/login' })
    }
  }
}
</script>
